import { FunctionComponent, useCallback, useState } from 'react';
import { Link, Stack, SvgIcon, Tab, Tabs, Typography } from '@mui/material';
import { Customer } from '@/models/customer';
import ArrowLeftIcon from '@heroicons/react/24/solid/ArrowLeftIcon';
import { FlexContainer } from '@/components/Layout/Container';
import { TabContext, TabPanel } from '@mui/lab';
import { CustomerDetailsCard } from '@/pages/customers/components/details/CustomerDetailsCard';
import { CustomerTicketsTable } from '@/pages/customers/components/details/CustomerTicketsTable';

type CustomerDetailsContentProps = {
    customer: Customer;
};

export const CustomerDetailsContent: FunctionComponent<
    CustomerDetailsContentProps
> = ({ customer }) => {
    const [tabValue, setTabValue] = useState('1');

    const handleTabChange = useCallback((_event, newValue: string) => {
        setTabValue(newValue);
    }, []);

    return (
        <TabContext value={tabValue}>
            <Stack
                sx={{
                    height: '100px',
                }}
                spacing={3}
            >
                <Link
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        color: 'text.primary',
                    }}
                    href='/kunden'
                >
                    <SvgIcon
                        fontSize='small'
                        sx={{
                            mr: 2,
                        }}
                    >
                        <ArrowLeftIcon />
                    </SvgIcon>

                    <Typography variant='subtitle2' component='span'>
                        Kunden
                    </Typography>
                </Link>

                <Stack spacing={6}>
                    <FlexContainer
                        sx={{ borderBottom: 1, borderColor: 'divider' }}
                    >
                        <Tabs value={tabValue} onChange={handleTabChange}>
                            <Tab label='Kunde details' value='1' />
                            <Tab label='Gekaufte Tickets' value='2' />
                        </Tabs>
                    </FlexContainer>
                    <TabPanel value='1'>
                        <CustomerDetailsCard customer={customer} />
                    </TabPanel>
                    <TabPanel value='2'>
                        <CustomerTicketsTable customer={customer} />
                    </TabPanel>
                </Stack>
            </Stack>
        </TabContext>
    );
};
